import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormGroup, FormGroupDirective } from '@angular/forms';
import { LANGUAGE_CONSTANTS as LANG_CONST } from 'src/app/shared/constants/language-constants';
import {
  convertDateTimeFormat,
  resetForm,
} from 'src/app/shared/utils/utility.service';
import { TranslateService } from '@ngx-translate/core';
import { BUILDING_USER_TYPES } from '../user-type/user-type.component';

@Component({
  selector: 'app-building-activity-detail',
  templateUrl: './building-activity-detail.component.html',
  styleUrls: ['./building-activity-detail.component.scss'],
})
export class BuildingActivityDetailComponent implements OnInit {
  /**
   * all necessary input get values from parent
   */
  @Input() dialogRef?: any; //close event of parent component
  @Input() stepper!: number;
  @Output() stepperChange = new EventEmitter<number>();
  @Output() submitToParent = new EventEmitter();
  @Output() resetFilterData = new EventEmitter();

  formGroupUserType!: FormGroup;
  formGroupDateRange!: FormGroup;
  formGroupLocks!: FormGroup;
  formGroupLockIds!: FormGroup;

  readonly LANG_CONST = LANG_CONST;

  constructor(
    public rootFormGroup: FormGroupDirective,
    private translate: TranslateService
  ) {}

  /**
   * @description formatted date range shown on the Date Range row
   */
  get dateFormat(): string {
    if (this.formGroupDateRange?.value?.dateTodateFrom) {
      return `${convertDateTimeFormat(
        this.formGroupDateRange.controls.dateTodateFrom.value.start,
        'yyyy/MM/dd'
      )} - ${convertDateTimeFormat(
        this.formGroupDateRange.controls.dateTodateFrom.value.end,
        'yyyy/MM/dd'
      )}`;
    }
    return '';
  }

  /**
   * @description translated label of the selected user type shown on the User Type row
   */
  get userTypeLabel(): string {
    const value: number | null =
      this.formGroupUserType?.value?.userType ?? null;
    const userType = BUILDING_USER_TYPES.find((type) => type.value === value);
    return userType ? this.translate.instant(userType.label) : '';
  }

  /**
   * @description selected activity-type labels shown on the Activity Type row
   */
  get activityTypeLabel(): string {
    const eventTypes = this.formGroupLocks?.value?.eventType;
    return eventTypes && eventTypes.length ? eventTypes.join(', ') : '';
  }

  /**
   * @description whether any filter is currently selected (drives Reset button highlight)
   */
  get hasSelection(): boolean {
    return (
      this.formGroupUserType?.value?.userType != null ||
      !!this.formGroupDateRange?.value?.dateTodateFrom ||
      (this.formGroupLocks?.value?.eventType?.length || 0) > 0
    );
  }

  ngOnInit(): void {
    this.formGroupUserType = this.rootFormGroup.control.get(
      'userType'
    ) as FormGroup;
    this.formGroupDateRange = this.rootFormGroup.control.get(
      'dateRange'
    ) as FormGroup;
    this.formGroupLocks = this.rootFormGroup.control.get('locks') as FormGroup;
    this.formGroupLockIds = this.rootFormGroup.control.get(
      'lockIds'
    ) as FormGroup;
  }

  /**
   * @description navigation to a filter sub-screen
   * @returns void
   */
  navigateTo(step: number): void {
    this.stepperChange.emit((this.stepper = step));
  }

  /**
   * @description apply the filter (submit the parent form)
   * @returns void
   */
  applyFilter(): void {
    this.submitToParent.emit();
  }

  /**
   * @description reset all filter selections
   * @returns void
   */
  resetFilter(): void {
    resetForm(this.formGroupUserType as FormGroup, null);
    resetForm(this.formGroupDateRange as FormGroup);
    resetForm(this.formGroupLocks as FormGroup, []);
    resetForm(this.formGroupLockIds as FormGroup, []);
    this.resetFilterData.emit();
  }
}
